import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Container, Row, Col, Modal } from "react-bootstrap";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchReservationCustomerMenu, fetchReservationActive, getRestaurantTimeZone, postPhoneConfirmation, postResendPhoneConfirmation, reconfirmationByClientAction } from "../actions/reservationsActions";
import { createReservationSlice } from "../reducers/reservationReducers";
import ReservationChat from "../components/ReservationChat";
import { fetchRestaurantDetails } from "../actions/restaurantActions";
import styled from "styled-components";
import Loader from "../components/Loader";
import Messages from "../components/Messages";
import ReservationScreen from "./ReservationScreen";
import { utcToZonedTime } from "date-fns-tz";
import { intervalToDuration, isBefore, isEqual } from "date-fns";
import LoaderComponent from "../components/LoaderComponent";
import { isValidNumber } from "libphonenumber-js";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { getCountryCode } from "../components/CountryCode";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cancelledStatuses, getReservationStatusTranslationClient, getReservationStatusColors, Strong } from "../components/ReservationStatus";
import { faTriangleExclamation, faCheck, faPhone, faUser, faCalendar, faStopwatch, faUsers, faBaby, faWheelchairMove, faEnvelope, faCircleXmark, faFilePen, faLock } from "@fortawesome/free-solid-svg-icons";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { DefaultDateExtended, ModernButton } from "../components/DefaultImports";
import { ConfirmationModal } from "../components/ConfirmationModal";
import { CustomModal } from "../components/CustomModal";

/* global google */

const Wrapper = styled(Container)`
  max-width: 800px;
  background-color: #faf6e9;
  padding: 16px 30px 30px;
  margin-top: 20px;
  border-radius: 5px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);

  p {
    margin-bottom: 7px;
  }

  @media (max-width: 768px) {
    margin-top: 8px;
    padding: 12px 16px calc(56px + env(safe-area-inset-bottom));
  }
`;
const Title = styled.h3`
  margin: 0 0 14px;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 22px;
`;
const ActionButtons = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  gap: 10px;
  justify-content: flex-start;
  padding: 10px 0 0 0;
  background: transparent;
  bottom: 0;

  @media (max-width: 768px) {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    margin: 0;
    gap: 0;
    background: #faf6e9;
    z-index: 10000;
    box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.2);
    padding: 0 env(safe-area-inset-right) env(safe-area-inset-bottom)
      env(safe-area-inset-left);

    & > * {
      flex: 1 1 0;
      height: 48px;
      margin: 0 !important;
      border-radius: 0 !important;
    }
  }
`;
function deepEqual(obj1, obj2) {
  if (obj1 === obj2) return true;
  if (typeof obj1 !== "object" || obj1 === null || typeof obj2 !== "object" || obj2 === null) {
    return false;
  }
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) return false;
  for (let key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }
  return true;
}
const ReservationCustomersMenuScreen = () => {
  const {
    t
  } = useTranslation();
  const params = useParams();
  const [showModal, setShowModal] = useState(false);
  const [reservationCancelled, setReservationCancelled] = useState(false);
  const [isReservationModalOpen, setIsReservationModalOpen] = useState(false);
  const [isTimeExpired, setIsTimeExpired] = useState(false);
  const [timeLeft, setTimeLeft] = useState(false);
  const [restaurant_id, setRestaurant_id] = useState("");
  const [reservationObj, setReservationObj] = useState(false);
  const [totalDuration, setTotalDuration] = useState(null);
  const [currentDuration, setCurrentDuration] = useState(totalDuration);
  const [randomizedNumbers, setRandomizedNumbers] = useState([]);
  const [phoneWS, setPhoneWS] = useState(false);
  const [countryCodeNumber, setCountryCodeNumber] = useState("351");
  const [countryCode, setCountryCode] = useState("us");
  const [phoneWithoutCountryCode, setPhoneWithoutCountryCode] = useState("");
  const [email, setEmail] = useState("");
  const [emailWM, setEmailWM] = useState(false);
  const [longitudeField, setLongitudeField] = useState(false);
  const [latitudeField, setLatitudeField] = useState(false);
  const [viewDistance, setViewDistance] = useState(18);
  const [chatModal, setChatModal] = useState(false);
  const [reservationStillPendingModal, setReservationStillPendingModal] = useState(false);
  const [verifyCancelReservation, setVerifyCancelReservation] = useState(false);
  const [showModalReconfirmation, setShowModalReconfirmation] = useState(false);
  const [isReconfirmActive, setIsReconfirmActive] = useState(false);
  const [isEditDisabled, setIsEditDisabled] = useState(false);
  const [isCancelDisabled, setIsCancelDisabled] = useState(false);
  const [showReconfirmSuccessModal, setShowReconfirmSuccessModal] = useState(false);

  // cooldown resend (segundos)
  const [resendCooldown, setResendCooldown] = useState(0);

  // MODAL confirmar contactos: aberto e se é "forçado"
  const [showConfirmContactModal, setShowConfirmContactModal] = useState(false);
  const [isConfirmContactForced, setIsConfirmContactForced] = useState(false);
  const reservationBlockedWeekDays = useSelector(state => state.reservationBlockedWeekDays);
  const {
    restaurantTimeZone
  } = reservationBlockedWeekDays;
  const reservation_info = useSelector(state => state.reservationCustomersMenu);
  const {
    reservation,
    isCustomerLoader
  } = reservation_info;
  const createReservationStore = useSelector(state => state.createReservation);
  const {
    isPhoneConfirmationLoading,
    phoneConfirmation = false,
    isResendPhoneConfirmationLoading
  } = createReservationStore;
  const restaurantDetails = useSelector(state => state.restaurantDetails);
  const {
    restaurants
  } = restaurantDetails;

  // Phone verification is exclusive to plan 6.
  const isPhoneContactVerificationAvailable = restaurants?.sub_lvl != null && ![0, 1, 2, 4, 5].includes(Number(restaurants.sub_lvl));
  const socket = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const id = useParams();
  const {
    isLoaded: isGoogleLoaded
  } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDtPooGWkj4z_ExlO9ggRMwwI9QiFZuZTI"
  });

  // ======= helpers =======

  const getRandomizedNumbers = (pinString, additionalNumber) => {
    let numbers = pinString.split(";");
    numbers.push(additionalNumber);
    numbers.sort(() => Math.random() - 0.5);
    return numbers;
  };
  const getTimeInSeconds = time => {
    if (typeof time !== "string") return 0;
    const [minutes, seconds] = time.split(":");
    if (!minutes || !seconds) return 0;
    return parseInt(minutes, 10) * 60 + parseInt(seconds, 10);
  };
  const validateEmail = theEmail => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(theEmail);
  };
  const formatCooldown = seconds => {
    const mm = String(Math.floor(seconds / 60)).padStart(2, "0");
    const ss = String(seconds % 60).padStart(2, "0");
    return `${mm}:${ss}`;
  };
  function openGoogleMapsDirections() {
    const latitude = latitudeField;
    const longitude = longitudeField;
    const googleMapsDirectionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
    window.open(googleMapsDirectionsUrl, "_blank");
  }

  // ======= fetches =======

  useEffect(() => {
    dispatch(fetchReservationCustomerMenu(id.token, id.change_status));
  }, [id.token, id.change_status, dispatch]);
  useEffect(() => {
    dispatch(fetchReservationCustomerMenu(id.token, id.change_status));
    dispatch(getRestaurantTimeZone(restaurant_id));
    dispatch(fetchReservationActive());
  }, [id.token, id.change_status, restaurant_id, dispatch]);
  useEffect(() => {
    if (reservation) {
      dispatch(fetchRestaurantDetails(reservation.restaurant));
    }
  }, [reservation, dispatch]);

  // ======= map coords =======

  useEffect(() => {
    if (restaurants) {
      setLongitudeField(parseFloat(restaurants.longitude));
      setLatitudeField(parseFloat(restaurants.latitude));
      setViewDistance(restaurants.view_distance);
    }
  }, [restaurants]);

  // ======= sync local contact fields =======

  useEffect(() => {
    if (Object.keys(reservationObj || {}).length !== 0) {
      let phoneWithoutCountryCoda;
      if (reservation && reservation.phone_number) {
        const countryCodeLength = countryCodeNumber.length;
        let phoneNumber = reservation.phone_number;
        if (phoneNumber[0] === "+") {
          phoneNumber = phoneNumber.slice(1);
        }
        phoneWithoutCountryCoda = phoneNumber.slice(countryCodeLength);
      }
      setCountryCodeNumber(reservationObj.country_code);
      setPhoneWithoutCountryCode(phoneWithoutCountryCoda);
      setEmail(reservationObj.email);
    }
  }, [reservationObj, reservation, countryCodeNumber]);
  useEffect(() => {
    setCountryCode(getCountryCode(countryCodeNumber));
  }, [countryCodeNumber]);
  useEffect(() => {
    if (reservationObj && reservationObj.confirmation_code_for_phone && !isResendPhoneConfirmationLoading) {
      const numbers = getRandomizedNumbers(reservationObj.confirmation_code_for_phone, reservationObj.confirmation_code_for_email?.slice(0, 2) || "00");
      setRandomizedNumbers(numbers);
    }
  }, [reservationObj, isResendPhoneConfirmationLoading]);

  // ======= timer =======

  useEffect(() => {
    if (reservationObj && reservationObj.date_time_limit_for_confirmation && restaurantTimeZone && reservationObj.status !== "accepted") {
      const zonedDateNow = utcToZonedTime(new Date(), restaurantTimeZone.timezone);
      const zonedDateLimit = new Date(reservationObj.date_time_limit_for_confirmation);
      const startTimer = () => {
        const now = new Date();
        const diff = intervalToDuration({
          start: now,
          end: zonedDateLimit
        });
        let minutes = diff.minutes || 0;
        let seconds = diff.seconds || 0;
        if (diff.hours) {
          minutes += diff.hours * 60;
        }
        const formattedTime = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
        if (zonedDateNow > zonedDateLimit) {
          clearInterval(interval);
          setTimeLeft(null);
          setIsTimeExpired(true);
        } else {
          setTimeLeft(formattedTime);
        }
      };
      const interval = setInterval(startTimer, 1000);
      startTimer();
      return () => clearInterval(interval);
    }
  }, [reservationObj, restaurantTimeZone]);
  useEffect(() => {
    if (timeLeft && typeof timeLeft === "string" && timeLeft.includes(":")) {
      setCurrentDuration(getTimeInSeconds(timeLeft));
      if (totalDuration === null) {
        setTotalDuration(getTimeInSeconds("05:00"));
      }
    }
  }, [totalDuration, timeLeft]);

  // ======= reservationObj sync =======

  useEffect(() => {
    if (reservation) {
      setReservationObj(reservation);
    }
  }, [reservation, restaurant_id]);

  // ======= initial popups =======

  useEffect(() => {
    let now = "0";
    if (restaurantTimeZone) {
      now = utcToZonedTime(new Date(), restaurantTimeZone.timezone);
    }
    if (!verifyCancelReservation && params.change_status === "cancel" && reservationObj && !cancelledStatuses.includes(reservationObj.status)) {
      setVerifyCancelReservation(true);
      setShowModal(true);
    } else if (params.change_status === "contact") {
      setChatModal(true);
    } else if (reservationObj.is_reconfirmation_message_sent && !reservationObj.reconfirmed_by_client) {
      setShowModalReconfirmation(true);
      setIsReconfirmActive(true);
    } else if (reservationObj && restaurantTimeZone && !cancelledStatuses.includes(reservationObj.status) && !reservationObj.reconfirmed_by_client) {
      const scheduledDate = new Date(reservationObj.reconfirmation_scheduled_for);
    }
  }, [params.change_status, reservationObj, restaurantTimeZone, verifyCancelReservation]);

  // Phone confirmation links are ignored unless the restaurant has plan 6.
  // Email confirmation continues to work for every plan.

  useEffect(() => {
    if (reservationObj && (isPhoneContactVerificationAvailable && params.change_status === "phone_confirmation" && !reservationObj.is_phone_confirmed || params.change_status === "email_confirmation" && !reservationObj.is_email_confirmed)) {
      dispatch(postPhoneConfirmation(reservationObj.token, params.change_status));
    }
  }, [params.change_status, reservationObj, isPhoneContactVerificationAvailable, dispatch]);

  // ======= cooldown ticking =======

  useEffect(() => {
    if (resendCooldown <= 0) return;
    const timer = setInterval(() => {
      setResendCooldown(seconds => seconds > 0 ? seconds - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, [resendCooldown]);

  // ======= websocket updates =======

  useEffect(() => {
    if (id) {
      const websocketBaseURL = process.env.REACT_APP_WEBSOCKET_URL;
      const websocket = new WebSocket(`${websocketBaseURL}reservation/${id.token}/`);
      socket.current = websocket;
      websocket.onmessage = event => {
        try {
          const data = JSON.parse(event.data);
          if (data.type === "reservation_update") {
            setReservationObj(data.reservation);
          }
        } catch (error) {
          console.error("Error parsing JSON:", error);
        }
      };
      websocket.onopen = () => console.log("WebSocket Connected");
      websocket.onclose = () => console.log("WebSocket Disconnected");
      return () => socket.current?.close();
    }
  }, [id]);

  // ======= actions =======

  const handleCancel = async () => {
    setShowModal(false);
    setShowModalReconfirmation(false);
    try {
      const data = {
        isCustomer: true,
        reservation_id: reservationObj.id
      };
      await axios.post("/api/reservations/cancel_reservation/", data);
    } catch (error) {
      console.error("Error cancelling reservation:", error);
    }
    setReservationCancelled(true);
    dispatch(fetchReservationCustomerMenu(id.token, true));
  };
  const handleReconfirmation = async () => {
    setShowModalReconfirmation(false);
    try {
      await dispatch(reconfirmationByClientAction(id.token));
      setShowReconfirmSuccessModal(true);
      setShowModalReconfirmation(false);
    } catch (error) {
      setShowReconfirmSuccessModal(true);
    }
  };
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseReservationModal = () => setIsReservationModalOpen(false);
  const handleOpenEditReservationModal = status => {
    if (status === "pending_restaurant" || status === "edited") {
      setReservationStillPendingModal(true);
    } else {
      setIsReservationModalOpen(true);
    }
  };

  // ======= confirmation modal logic =======

  const missingEmail = reservationObj?.is_email_confirmed === false;

  // This is always false for plans 0, 1, 2, 4 and 5.
  // Therefore, the phone field and phone warning are completely hidden.
  const missingPhone = isPhoneContactVerificationAvailable && reservationObj?.is_phone_confirmed === false;
  const bothUnconfirmed = Boolean(reservationObj) && missingEmail && missingPhone;
  const anyUnconfirmed = Boolean(reservationObj) && (missingEmail || missingPhone);
  const fullPhone = `+${countryCodeNumber}${phoneWithoutCountryCode || ""}`;
  const isPhoneOk = !missingPhone || phoneWithoutCountryCode && phoneWithoutCountryCode.length >= 3 && isValidNumber(fullPhone);
  useEffect(() => {
    if (bothUnconfirmed) {
      setShowConfirmContactModal(true);
      setIsConfirmContactForced(true);
    } else if (isConfirmContactForced) {
      setShowConfirmContactModal(false);
      setIsConfirmContactForced(false);
    }
  }, [bothUnconfirmed, isConfirmContactForced]);
  const handleResendPhoneCode = () => {
    if (resendCooldown > 0) return;
    setEmailWM(false);
    setPhoneWS(false);
    if (missingEmail && !validateEmail(email)) {
      setEmailWM(true);
      return;
    }
    if (missingPhone && !isPhoneOk) {
      setPhoneWS(true);
      return;
    }
    dispatch(postResendPhoneConfirmation(reservationObj.token, countryCodeNumber, countryCodeNumber + (phoneWithoutCountryCode || ""), email));
    setResendCooldown(60);
  };
  const modalLeadText = bothUnconfirmed ? "Acede ao teu WhatsApp ou e-mail para confirmares o teu contacto." : missingEmail ? isPhoneContactVerificationAvailable ? "Falta confirmar o teu e-mail. O telemóvel já está confirmado." : "Falta confirmar o teu e-mail." : missingPhone ? "Falta confirmar o teu telemóvel através do WhatsApp." : "";
  return <div style={{
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }}>
      <LoaderComponent activate={isPhoneConfirmationLoading || isResendPhoneConfirmationLoading || isCustomerLoader} theSize="o" />

      {Object.keys(reservationObj || {}).length !== 0 ? <Wrapper>
          <Title>{t("ui.screens.reservationCustomersMenuScreen.aTuaReservaNo")}{restaurants && restaurants.restaurant_name}"
          </Title>

          <div style={{
        width: "100%",
        marginBottom: 16
      }}>
            {reservationObj.is_edition_accepted && <Messages color="#4CAE4C">
                <Strong>{t("ui.screens.reservationCustomersMenuScreen.alteracaoAceite")}</Strong>
              </Messages>}

            {reservationObj.is_edition_rejected && <Messages color="#D94B4B">
                <Strong>{t("ui.screens.reservationCustomersMenuScreen.alteracaoRecusada")}</Strong>
              </Messages>}

            <h4>
              {getReservationStatusTranslationClient(reservationObj.status)}
            </h4>
          </div>

          <Row>
            <Col style={{
          position: "relative"
        }} xs={12} sm={12} md={6}>
              {anyUnconfirmed && <div onClick={() => {
            setShowConfirmContactModal(true);
            setIsConfirmContactForced(false);
          }} onKeyDown={event => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              setShowConfirmContactModal(true);
              setIsConfirmContactForced(false);
            }
          }} style={{
            width: "100%",
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            gap: 10,
            flexWrap: "wrap",
            cursor: "pointer"
          }} role="button" tabIndex={0} title={t("ui.screens.reservationCustomersMenuScreen.clicaParaConfirmar")}>
                  {missingEmail && <div style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              padding: "4px 10px",
              backgroundColor: "#fff",
              borderRadius: 999,
              color: "#4B3335",
              fontSize: "12px",
              fontWeight: 600,
              boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
              width: "fit-content",
              flex: "0 0 auto",
              boxSizing: "border-box"
            }}>
                      <FontAwesomeIcon icon={faTriangleExclamation} style={{
                color: "#EE754C"
              }} />

                      <span style={{
                whiteSpace: "nowrap"
              }}>{t("ui.screens.reservationCustomersMenuScreen.confirmaOTeu")}{" "}
                        <span style={{
                  color: "#EE561B"
                }}>{t("ui.screens.reservationCustomersMenuScreen.email")}</span>
                      </span>
                    </div>}

                  {missingPhone && <div style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              padding: "4px 10px",
              backgroundColor: "#fff",
              borderRadius: 999,
              color: "#4B3335",
              fontSize: "12px",
              fontWeight: 600,
              boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
              width: "fit-content",
              flex: "0 0 auto",
              boxSizing: "border-box"
            }}>
                      <FontAwesomeIcon icon={faTriangleExclamation} style={{
                color: "#EE754C"
              }} />

                      <span style={{
                whiteSpace: "nowrap"
              }}>{t("ui.screens.reservationCustomersMenuScreen.confirmaOTeu2")}{" "}
                        <span style={{
                  color: "#EE561B"
                }}>{t("ui.screens.reservationCustomersMenuScreen.telemovel")}</span>
                      </span>
                    </div>}
                </div>}

              <p>
                <FontAwesomeIcon icon={faUser} style={{
              color: "#EE754C",
              marginRight: "5px"
            }} />{" "}
                {reservationObj.full_name}
              </p>

              <p>
                <FontAwesomeIcon icon={faCalendar} style={{
              color: "#EE754C",
              marginRight: "5px"
            }} />{" "}
                <DefaultDateExtended date={reservationObj.date} />
              </p>

              <p>
                <FontAwesomeIcon icon={faStopwatch} style={{
              color: "#EE754C",
              marginRight: "10px"
            }} />
                {reservationObj.time}
              </p>

              <p style={{
            marginLeft: "-3px"
          }}>
                <FontAwesomeIcon icon={faUsers} style={{
              color: "#EE754C",
              marginRight: "3px"
            }} />{" "}
                {reservationObj.number_of_people}{t("ui.screens.reservationCustomersMenuScreen.pessoas")}</p>

              {reservationObj.baby_chair > 0 && <p>
                  <FontAwesomeIcon icon={faBaby} style={{
              color: "#EE754C",
              marginRight: "5px"
            }} />{" "}
                  {reservationObj.baby_chair}
                </p>}

              {reservationObj.accessability === "wheel_chair" && <p>
                  <FontAwesomeIcon icon={faWheelchairMove} style={{
              color: "#EE754C",
              marginRight: "5px"
            }} />{" "}{t("ui.screens.reservationCustomersMenuScreen.acessoFacil")}</p>}

              {reservationObj.message !== "" && reservationObj.message !== null && <p>
                    <FontAwesomeIcon icon={faEnvelope} style={{
              color: "#EE754C",
              marginRight: "5px"
            }} />{" "}
                    {reservationObj.message}
                  </p>}

              {!cancelledStatuses.includes(reservationObj.status) && <ActionButtons>
                  <ModernButton onClick={handleShowModal} color={isCancelDisabled ? "#9FBBC1" : "#99B0AD"} disabled={isCancelDisabled}>
                    {isCancelDisabled ? <>{t("ui.screens.reservationCustomersMenuScreen.cancelarReserva")}{" "}
                        <FontAwesomeIcon icon={faLock} style={{
                  color: "#ffffff",
                  marginLeft: "7px"
                }} />
                      </> : <>{t("ui.screens.reservationCustomersMenuScreen.cancelarReserva2")}{" "}
                        <FontAwesomeIcon icon={faCircleXmark} style={{
                  color: "#ffffff",
                  marginLeft: "7px"
                }} />
                      </>}
                  </ModernButton>

                  <ModernButton onClick={() => handleOpenEditReservationModal(reservationObj.status)} color={isEditDisabled ? "#99B0AD" : "#EE754C"} disabled={isEditDisabled}>
                    {isEditDisabled ? <>{t("ui.screens.reservationCustomersMenuScreen.editarReserva")}{" "}
                        <FontAwesomeIcon icon={faLock} style={{
                  color: "#ffffff",
                  marginLeft: "7px"
                }} />
                      </> : <>{t("ui.screens.reservationCustomersMenuScreen.editarReserva2")}{" "}
                        <FontAwesomeIcon icon={faFilePen} style={{
                  color: "#ffffff",
                  marginLeft: "7px"
                }} />
                      </>}
                  </ModernButton>
                </ActionButtons>}
            </Col>

            {isGoogleLoaded && restaurants && <Col xs={12} sm={12} md={6}>
                <div style={{
            display: "flex",
            gap: "10px",
            width: "100%",
            marginBottom: "10px"
          }}>
                  <div style={{
              flex: 1
            }}>
                    <ReservationChat reservation={reservationObj} isClient setChatModalTrueOrFalse={setChatModal} openModal={chatModal} />
                  </div>

                  <a href={`tel:+${restaurants.country_code}${restaurants.phone_number}`} style={{
              flex: 1,
              cursor: "pointer",
              color: "white",
              backgroundColor: "#EE754C",
              height: "40px",
              fontSize: "14px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textDecoration: "none",
              borderRadius: "5px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
            }}>
                    <FontAwesomeIcon size="lg" icon={faPhone} style={{
                marginRight: "6px"
              }} />{t("ui.screens.reservationCustomersMenuScreen.telefonar")}</a>
                </div>

                <div onClick={openGoogleMapsDirections} onKeyDown={event => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              openGoogleMapsDirections();
            }
          }} role="button" tabIndex={0} style={{
            width: "100%",
            height: "225px",
            borderRadius: "7px",
            overflow: "hidden",
            cursor: "pointer",
            position: "relative"
          }}>
                  <div style={{
              width: "100%",
              height: "35px",
              backgroundColor: "#EE754C",
              color: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "16px",
              fontWeight: "bold"
            }}>{t("ui.screens.reservationCustomersMenuScreen.morada")}</div>

                  <div style={{
              width: "100%",
              height: "190px",
              border: "none"
            }}>
                    <GoogleMap mapContainerStyle={{
                width: "100%",
                height: "100%"
              }} mapContainerClassName="map-container-customer-view" onLoad={map => {
                if (google && google.maps) {
                  google.maps.event.trigger(map, "resize");
                }
              }} center={{
                lat: latitudeField,
                lng: longitudeField
              }} zoom={viewDistance} options={{
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
                zoomControl: false,
                gestureHandling: "none"
              }}>
                      <Marker position={{
                  lat: latitudeField,
                  lng: longitudeField
                }} />
                    </GoogleMap>

                    <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                cursor: "pointer"
              }} />
                  </div>
                </div>
              </Col>}
          </Row>

          <Modal show={showConfirmContactModal && anyUnconfirmed} onHide={() => {
        if (!isConfirmContactForced) {
          setShowConfirmContactModal(false);
        }
      }} backdrop={isConfirmContactForced ? "static" : true} keyboard={!isConfirmContactForced} centered>
            <Modal.Header closeButton={!isConfirmContactForced}>
              <Modal.Title>{t("ui.screens.reservationCustomersMenuScreen.verificacaoDeContacto")}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <p style={{
            marginBottom: 10,
            color: "black"
          }}>
                {modalLeadText}
              </p>

              {missingEmail && <div style={{
            marginBottom: 12
          }}>
                  <label style={{
              fontSize: 13,
              fontWeight: 800,
              color: "#4B3335"
            }}>{t("ui.screens.reservationCustomersMenuScreen.email2")}</label>

                  <input value={email || ""} onChange={event => setEmail(event.target.value)} placeholder={t("ui.screens.reservationCustomersMenuScreen.exNomeEmailCom")} style={{
              width: "100%",
              height: 42,
              borderRadius: 6,
              border: emailWM ? "2px solid #D94B4B" : "1px solid rgba(0,0,0,0.15)",
              padding: "0 12px",
              outline: "none",
              marginTop: 6,
              background: "#fff"
            }} />

                  {emailWM && <div style={{
              marginTop: 6,
              fontSize: 12,
              color: "#D94B4B"
            }}>{t("ui.screens.reservationCustomersMenuScreen.emailInvalidoCorrigeParaConseguiresReenviar")}</div>}
                </div>}

              {/* This complete section is hidden for plans 0, 1, 2, 4 and 5. */}
              {missingPhone && <div style={{
            marginBottom: 10
          }}>
                  <label style={{
              fontSize: 13,
              fontWeight: 800,
              color: "#4B3335"
            }}>{t("ui.screens.reservationCustomersMenuScreen.telemovel2")}</label>

                  <div style={{
              marginTop: 6
            }}>
                    <PhoneInput country={countryCode} value={`${countryCodeNumber}${phoneWithoutCountryCode || ""}`} onChange={(value, data) => {
                const normalizedValue = String(value || "").replace("+", "");
                const dialCode = String(data?.dialCode || "");
                if (data?.countryCode) {
                  setCountryCode(data.countryCode);
                }
                if (dialCode) {
                  setCountryCodeNumber(dialCode);
                }
                if (dialCode && normalizedValue.startsWith(dialCode)) {
                  setPhoneWithoutCountryCode(normalizedValue.slice(dialCode.length));
                } else {
                  setPhoneWithoutCountryCode(normalizedValue);
                }
              }} inputStyle={{
                width: "100%",
                height: 42,
                borderRadius: 6,
                border: phoneWS ? "2px solid #D94B4B" : "1px solid rgba(0,0,0,0.15)",
                background: "#fff"
              }} buttonStyle={{
                borderTopLeftRadius: 6,
                borderBottomLeftRadius: 6,
                border: phoneWS ? "2px solid #D94B4B" : "1px solid rgba(0,0,0,0.15)",
                background: "#fff"
              }} containerStyle={{
                width: "100%"
              }} specialLabel="" />
                  </div>

                  {phoneWS && <div style={{
              marginTop: 6,
              fontSize: 12,
              color: "#D94B4B"
            }}>{t("ui.screens.reservationCustomersMenuScreen.numeroDeTelemovelPareceInvalido")}</div>}
                </div>}
            </Modal.Body>

            <Modal.Footer style={{
          display: "flex",
          gap: 10
        }}>
              <ModernButton onClick={() => {
            dispatch(fetchReservationCustomerMenu(id.token, id.change_status));
            if (!isConfirmContactForced) {
              setShowConfirmContactModal(false);
            }
          }} color="#99B0AD" style={{
            flex: 1
          }}>{t("ui.screens.reservationCustomersMenuScreen.jaConfirmei")}</ModernButton>

              <ModernButton onClick={handleResendPhoneCode} color="#EE754C" style={{
            flex: 1
          }} disabled={isResendPhoneConfirmationLoading || isPhoneConfirmationLoading || resendCooldown > 0}>
                {resendCooldown > 0 ? `Reenviar (${formatCooldown(resendCooldown)})` : "Enviar confirmação novamente"}
              </ModernButton>
            </Modal.Footer>
          </Modal>

          <ConfirmationModal show={showModal} onHide={handleCloseModal} onConfirm={handleCancel} title={t("ui.screens.reservationCustomersMenuScreen.cancelarReserva3")} body="Tens a certeza que pretendes cancelar a tua reserva?" confirmLabel="Cancelar reserva" cancelColor="#99B0AD" cancelLabel="Manter reserva" confirmColor="#EE754C" />

          <ConfirmationModal show={phoneConfirmation !== false} onHide={() => {
        dispatch(createReservationSlice.actions.postPhoneConfirmationReset());
      }} onConfirm={() => {
        dispatch(createReservationSlice.actions.postPhoneConfirmationReset());
      }} title={<>
                <FontAwesomeIcon icon={faCheck} />{" "}
                {phoneConfirmation.message === "phone_confirmation" ? "Telemóvel confirmado" : "E-mail confirmado"}
              </>} body={<>
                {phoneConfirmation.message === "phone_confirmation" ? "Obrigado por confirmar o telemóvel." : "Obrigado por confirmar o e-mail."}
              </>} confirmLabel="OK" confirmColor="#EE754C" />

          <ConfirmationModal show={showModalReconfirmation} onConfirm={handleReconfirmation} onCancel={() => setShowModal(true)} title={t("ui.screens.reservationCustomersMenuScreen.confirmasATuaPresenca")} confirmLabel="Confirmar" cancelLabel="Não vou comparecer" confirmColor="#EE754C" cancelColor="#99B0AD" blockCloseButton />

          <CustomModal show={showReconfirmSuccessModal} onHide={() => setShowReconfirmSuccessModal(false)} title={t("ui.screens.reservationCustomersMenuScreen.presencaConfirmada")}>
            <div style={{
          padding: "8px 2px"
        }}>
              <p style={{
            marginBottom: 12
          }}>{t("ui.screens.reservationCustomersMenuScreen.obrigadoAguardamosATuaChegada")}</p>

              <div style={{
            display: "flex",
            justifyContent: "flex-end"
          }}>
                <ModernButton onClick={() => setShowReconfirmSuccessModal(false)} color="#EE754C">{t("ui.screens.reservationCustomersMenuScreen.fechar")}</ModernButton>
              </div>
            </div>
          </CustomModal>

          <CustomModal show={isReservationModalOpen} onHide={() => setIsReservationModalOpen(false)} title={t("ui.screens.reservationCustomersMenuScreen.editarReserva3")}>
            <ReservationScreen from_restaurant={false} creating={false} setCreating={false} isEditModalOpen={isReservationModalOpen} setIsEditModalOpen={setIsReservationModalOpen} restaurantId={restaurant_id} handleCloseReservationModal={handleCloseReservationModal} token_from_restaurant={id.token} no_border />
          </CustomModal>

          <ConfirmationModal show={reservationStillPendingModal} onHide={() => setReservationStillPendingModal(false)} onConfirm={() => setReservationStillPendingModal(false)} title={t("ui.screens.reservationCustomersMenuScreen.aviso")} body={<>{t("ui.screens.reservationCustomersMenuScreen.naoEPossivelFazerAlteracoesA")}<br />{t("ui.screens.reservationCustomersMenuScreen.sePretenderFazerUmaAlteracaoPor")}</>} confirmLabel="OK" confirmColor="#EE754C" />
        </Wrapper> : <Loader />}
    </div>;
};
export default ReservationCustomersMenuScreen;
